export default __webpack_public_path__ + "static/media/reacher_s2_002.aac2e2ce.jpg";